import React from 'react'
import { Helmet } from 'react-helmet'

import { Box, Text } from 'system'
import { Overlay, Header } from './'

import 'typeface-inter'
import 'typeface-ibm-plex-mono'
import 'minireset.css'

export const Layout = ({ withHeader = true, ...props }) => (
  <>
    <Helmet titleTemplate={`%s – Web Reference`} defaultTitle="Web Reference">
      <html lang="en" />
      <meta name="robots" content="noindex" />
    </Helmet>
    <Text
      as="div"
      color="slate.20"
      fontFamily="sans"
      fontSizeScale="b"
      lineHeight="ui"
      position="relative"
    >
      {withHeader && <Header />}
      <Box as="main" {...props} />
      <Overlay />
    </Text>
  </>
)
